import firebase from 'firebase/app';
import 'firebase/auth';

export function getCurrentFirebaseUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject)
  });
}

